export default {
  PNP_1: {
    title: 'Total de publicações Owned e Earned',
    description: 'Somatório de publicações proprietárias e não proprietárias coletadas na pesquisa.',
  },
  PNP_2: {
    title: 'Alcance Sentimento por Tag Owned + Earned',
    description: 'soma do alcance e distribuição de publicações proprietárias e não proprietárias pelas Tags cadastradas na pesquisa e sua divisão por polaridade.',
  },
  PNP_3: {
    title: 'Sentimento por termo Owned + Earned',
    description: 'soma da distribuição de publicações proprietárias e não proprietárias  por termos mais mencionados e sua divisão de polaridade.',
  },
  PNP_4: {
    title: 'Sentimento por tema Owned + Earned',
    description: 'Soma da distribuição de publicações proprietárias e não proprietárias pelos Temas cadastrados na pesquisa mais mencionados e sua divisão de polaridade.',
  },
  PNP_5: {
    title: 'Saúde da marca Owned + Earned',
    description: 'Representa, em forma de gauge, o resultado da equação: (publicações proprietárias e não proprietárias positivas / publicações proprietárias e não proprietárias coletadas * 100) - (publicações proprietárias e não proprietárias negativas / publicações proprietárias e não proprietárias coletadas * 100).',
  },
  PNP_6: {
    title: 'Distribuição por Canal Owned + Earned',
    description: 'Divisão das publicações por canal de coleta proprietárias e não proprietárias.',
  },
  PNP_7: {
    title: 'Total de usuários para Owned e Earned',
    description: 'Contagem de usuários únicos que geraram o total de publicações proprietárias e não-proprietárias na pesquisa.',
  },
  PNP_8: {
    title: 'Alcance Potencial para Owned e Earned',
    description: 'Representa 20% da somatória de seguidores/inscritos dos perfis coletados na pesquisa para publicações proprietárias e não proprietárias.',
  },
  PNP_9: {
    title: 'Publicações por tag para Owned e Earned',
    description: 'Distribuição de publicações pelas tags atribuídas para Owned e Earned',
  },
  PNP_10: {
    title: 'Total de publicações únicas Owned e Earned',
    description: 'Somatório de publicações únicas proprietárias e não proprietárias coletadas na pesquisa.',
  },
  PNP_11: {
    title: 'Sentimento no tempo para publicações e interações',
    description: 'Distribuição da somatória de publicações e interações recebidas por sua polaridade ao longo de um período de tempo..',
  },
  PNP_12: {
    title: 'Publicações por Tag no Tempo',
    description: 'Distribuição do somatório de publicações proprietárias e não proprietárias pelas Tags atribuídas na pesquisa ao longo do tempo.',
  },
  PNP_13: {
    title: 'Publicações no tempo',
    description: 'Distribuição linear da soma de publicações e interações de Listening + Métricas Proprietárias coletadas ao longo de um período de tempo.',
  },
  PNP_14: {
    title: 'Distribuição por Sentimento',
    description: 'Soma de publicações e interações (Listening + Métricas Proprietárias) divididas por polaridade positiva, negativa ou neutra.',
  },
  PNP_15: {
    title: 'Projeção amostragem de publicações',
    description: 'Projeção de publicações amostradas para Listening + Métricas Proprietárias.',
  },
  PNP_16: {
    title: 'Total de publicações, compartilhamentos e comentários',
    description: 'Somatório de publicações proprietárias e não proprietárias, compartilhamentos e comentários.',
  },
  PNP_17: {
    title: 'Total de publicações, compartilhamentos e comentários no Tempo',
    description: 'Distribuição do somatório de publicações proprietárias e não proprietárias, compartilhamentos e comentários ao longo do tempo.',
  },
};
